module.exports = __webpack_public_path__ + "img/momo_index_button_bg.9b4ca15b.png";